import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { HeaderParams } from '@models/ag-grid';

@Component({
    selector: 'app-ag-grid-header',
    templateUrl: './ag-grid-header.component.html',
    styleUrls: ['./ag-grid-header.component.scss'],
    standalone: false,
})
export class AgGridHeaderComponent implements IHeaderAngularComp, AfterViewInit {
    @ViewChild('floatingFilterContainer', { read: ElementRef }) floatingFilterContainer!: ElementRef;

    params!: HeaderParams;
    sortIcon = 'fas fa-fw fa-sort';

    constructor() {}

    agInit(params: HeaderParams) {
        this.params = params;

        this.params.api.addEventListener('sortChanged', (event) =>
            this.updateSortIcon(event.api.getColumnState().find((col) => col.colId === this.params.column.getColId())?.sort),
        );
        this.updateSortIcon(null);
    }

    isFilterActive(): boolean {
        return this.params.column?.getColDef()?.filter;
    }

    ngAfterViewInit() {
        const floatingFilterEl = document.querySelector(`.ag-floating-filter [col-id="${this.params.column?.getColId()}"]`);
        if (floatingFilterEl && this.floatingFilterContainer?.nativeElement) {
            const inputWrapper = floatingFilterEl.querySelector('.ag-wrapper');
            if (inputWrapper) {
                this.floatingFilterContainer.nativeElement.appendChild(inputWrapper);
            }
        }
    }

    openFilterMenu(event: MouseEvent, target: HTMLElement) {
        event.stopPropagation(); // Prevent sort() from triggering
        this.params.showFilter(target);
    }

    sort() {
        if (this.params.enableSorting) {
            this.params.progressSort();
        }
    }

    refresh() {
        return true;
    }

    updateSortIcon(sortDirection: 'asc' | 'desc' | null | undefined) {
        switch (sortDirection) {
            case 'asc':
                this.sortIcon = 'fas fa-fw fa-arrow-up';
                break;
            case 'desc':
                this.sortIcon = 'fas fa-fw fa-arrow-down';
                break;
            default:
                this.sortIcon = 'fas fa-fw fa-sort';
        }
    }
}
